export default {
  QUERY_PRODUCT_TYPE: {
    url: '/api/v1/products/types',
    method: 'get',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  QUERY_PRODUCT_LIST: {
    url: '/api/v1/products',
    method: 'get',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  SAVE_PRODUCT: {
    url: '/api/v1/admin/products',
    method: 'post',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  PUT_PRODUCT: {
    url: '/api/v1/admin/products',
    method: 'put',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  DELETE_PRODUCT: {
    url: '/api/v1/admin/products',
    method: 'delete',
    disableSuccessMsg: false,
    disableErrorMsg: false
  }
}
